import type { PaymentSubscriptionApiAttributes } from '@lingoda/api';
import { createAction, makeActionTrackable } from '@lingoda/core';
import type { PaymentOptions } from '../models';

type Payload = PaymentSubscriptionApiAttributes & PaymentOptions;

export default makeActionTrackable(createAction<Payload>('payment/RETRY_PAYMENT'));
